import React, { useEffect, useRef, useState } from 'react'
import { v4 } from 'uuid';
import { AnimatePresence, motion } from 'framer-motion';
import logo from '../../../assets/logo.jpeg'
import { PaperAirplaneIcon } from '@heroicons/react/24/solid'

const ChatBox = () => {


    let idExists = localStorage.getItem('userId')

    const [messages, setMessages] = useState([]);
    const [ws, setWs] = useState(null);
    const [newMessageText, setNewMessageText] = useState('');
    const [userId, setuserId] = useState(idExists && idExists)
    const divUnderMessages = useRef();


    useEffect(() => {

        connectToWs();

        if (idExists) {
            fetch(`${process.env.REACT_APP_SERVER_URL}/message/` + idExists)
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setMessages(data.message)
                    }
                })
        }
    }, []);

    function connectToWs() {

        let id = userId

        if (!userId) {
            let id = v4()
            localStorage.setItem('userId', id)
            setuserId(id)
        }

        const ws = new WebSocket(`wss://woolen-recondite-equipment.glitch.me?userId=${id}`);
        setWs(ws);
        ws.addEventListener('open', () => {
            console.log('WebSocket connection opened');
        });

    }

    function sendMessage(ev, file = null) {
        if (ev) ev.preventDefault();
        ws.send(JSON.stringify({
            recipient: 'this is admin',
            text: newMessageText,
        }));

        setNewMessageText('');
        setMessages(prev => ([...prev, {
            text: newMessageText,
            sender: userId,
            recipient: 'this is admin',
            _id: Date.now(),
        }]));

    }

    useEffect(() => {
        const div = divUnderMessages.current;
        if (div) {
            div.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }, [messages]);

    console.log(messages)


    return (
        <div className='fixed left-[20px] z-30 bottom-[90px] h-[400px] w-[350px]  rounded-md'>
            <AnimatePresence>
                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                >
                    <div className='bg-white shadow-md h-[400px] w-[330px] rounded-md'>
                        <div className='bg-black rounded-t-md p-3 flex gap-2 items-center'>
                            <img src={logo} alt="logo" className='h-6 w-6 rounded-full' />
                            <div>
                                <h1 className='text-white font-bold text-[13px]'>
                                    CodeZone
                                </h1>
                                <h2 className='text-white text-[11px]'>
                                    We typically reply in few minutes
                                </h2>
                            </div>
                        </div>
                        <div className='h-[290px] bg-gray-50 px-2 py-3 overflow-y-auto'>
                            <div>

                                <div className='imessage hover:scale-95 duration-700'>
                                    <p className={'from-them'}>
                                        Welcome to CodeZone! We are here to answer your questions.
                                    </p>
                                </div>
                            </div>
                            {messages && messages.length > 0 && messages.map((message, i) => (
                                <div key={i}>
                                    {message.text && (
                                        <div className={`${message.sender === userId && 'flex justify-end'}`}>
                                            <div className='imessage hover:scale-95 duration-700'>
                                                <p className={`${message.sender === userId ? 'from-me' : 'from-them'}`}>
                                                    {message.text}
                                                </p>
                                            </div>
                                        </div>

                                    )}
                                </div>
                            ))}

                            <div ref={divUnderMessages} />

                        </div>

                        <form className='px-2 pt-1 flex items-center' onSubmit={sendMessage}>
                            <input
                                type="text"
                                placeholder='Write a message'
                                className='outline-none focus:outline-none text-[13px] w-full'
                                value={newMessageText}
                                onChange={ev => setNewMessageText(ev.target.value)}
                            />
                            <button
                                disabled={!newMessageText && true}
                            >
                                <PaperAirplaneIcon className={`h-4 ${!newMessageText && 'cursor-not-allowed'} text-gray-500 hover:text-black duration-700`} />
                            </button>
                        </form>
                    </div>

                </motion.div>
            </AnimatePresence>
        </div >
    )
}

export default ChatBox